import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BasePostProvider } from "@tendercuts/http";
import { GenericServerResponse } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class AutoRoutesService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof GenericServerResponse {
    return GenericServerResponse;
  }

  get endpoint(): string {
    return this.endpointService.autoRoutes();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(
    storeId: string,
    orderCount: number,
  ): {
    store_id: string;
    order_per_trip: number;
  } {
    const params: {
      store_id: string;
      order_per_trip: number;
    } = {
      store_id: storeId.toString(),
      order_per_trip: orderCount,
    };

    return params;
  }
}
